<template>
  <div class="analytics-connect" v-if="!gaIsSetup">
    <div class="analytics-inner">
      <h1 class="analytics-heading">Connect</h1>
      <p class="analytics-body">In order to see Traffic you’ll need to connect your <a class="analytics-text-link" href="//analytics.google.com" target="_blank">Google Analytics</a> account.</p>
      <div class="analytics-actions">
        <a class="analytics-btn" :href="gaIntegration._links.authorize_url.href" v-if="gaIntegration && !gaIntegration.connected" target="_parent">Connect</a>
        <button class="analytics-btn" @click="gaSetShow(true)" v-if="gaIntegration && gaIntegration.connected">Setup</button>
        <img src="../../assets/images/icon-ga.svg" />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'

  export default {
    name: 'AnalyticsConnect',
    computed: {
      ...mapState(
        'ga', [
          'gaIntegration',
          'gaIsSetup'
        ]
      )
    },
    methods: {
      ...mapMutations(
        'ga', [
          'gaSetShow'
        ]
      )
    }
  }
</script>

<style lang="scss" scoped>
  .analytics {
    &-connect {
      margin-top: 35px;
      @media screen and (min-width: 1200px) {
        margin-top: 32px;
      }
      background-color: #fafafa;
      border: 1px solid #ededed;
      border-radius: 4px;
    }

    &-inner {
      padding: 30px;
      @media screen and (min-width: 768px) {
        padding: 40px;
      }
    }

    &-heading {
      font-family: 'Roboto Bold';
      font-size: 26px;
      @media screen and (min-width: 768px) {
        font-size: 32px;
      }
      color: #000000;
      letter-spacing: -0.46px;
      line-height: 25px;
      margin-bottom: 17px;
    }

    &-body {
      font-family: 'Roboto';
      font-size: 14px;
      @media screen and (min-width: 768px) {
        font-size: 16px;
      }
      color: #000000;
      letter-spacing: 0;
      line-height: 26px;
    }

    &-actions {
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin-top: 29px;
      flex-direction: column;
      @media screen and (min-width: 768px) {
        flex-direction: row;
      }
    }

    &-btn {
      background: #21CE99;
      &:hover {
        background: lighten(#21CE99, 15%);
      }
      box-shadow: 0 1px 1px 0 rgba(225,225,225,0.50);
      border-radius: 3px;
      min-height: 46px;
      padding: 0 20px;
      font-family: 'Roboto Medium';
      font-size: 15px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      color: #fff;
      min-width: 155px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;
      @media screen and (min-width: 768px) {
        margin-bottom: 0;
      }
    }

    &-text-link {
      text-decoration: underline;
      color: #737373;
    }
  }

</style>


// WEBPACK FOOTER //
// src/js/components/AnalyticsConnect.vue